import { cn } from '@/utils/cn';

export type RadioOption<T extends string = string> = { value: T; label: string; disabled?: boolean };

interface RadioGroupProps<T extends string> {
  name: string;
  value?: T;
  options: RadioOption<T>[];
  onChange?: (value: T) => void;
  row?: boolean;
  className?: string;
}

export function RadioGroup<T extends string>({
  name,
  value,
  options,
  onChange,
  row,
  className,
}: RadioGroupProps<T>) {
  return (
    <div
      role="radiogroup"
      className={cn(className)}
      style={{
        display: 'flex',
        flexDirection: row ? 'row' : 'column',
        gap: row ? 16 : 6,
        flexWrap: row ? 'wrap' : undefined,
      }}
    >
      {options.map((opt) => {
        const checked = value === opt.value;
        return (
          <label
            key={opt.value}
            className="ds-cb-row"
            aria-disabled={opt.disabled || undefined}
            style={{ cursor: opt.disabled ? 'not-allowed' : 'pointer' }}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={checked}
              disabled={opt.disabled}
              onChange={() => onChange?.(opt.value)}
              style={{
                width: 15,
                height: 15,
                margin: 0,
                accentColor: 'var(--brand)',
              }}
            />
            <span>{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}
